module.exports = __webpack_public_path__ + "static/aperfeicoamento-e150f1bf18360da25423b3807ae3213a.png";